import gql from 'graphql-tag';

export const fragments = {
  address: gql`
    fragment AddressFragment on AddressCartV2 {
      id
      firstName
      lastName
      phoneNumber
      company
      countryCode
      street
      city
      postcode
      hash
      default
      deliveryInstruction
    }
  `,
};

export const GET_ADDRESSES = gql`
  query GetAddresses {
    getAddresses {
      ...AddressFragment
    }
  }

  ${fragments.address}
`;

export const GET_ADDRESSES_WITH_DEFAULT_ONE = gql`
  query GetAddressesWithDefaultOne {
    getAddressesWithDefaultOne {
      ...AddressFragment
    }
  }

  ${fragments.address}
`;

export const CREATE_ADDRESS = gql`
  mutation CreateAddress($address: OmsAddress!) {
    createAddress(address: $address) {
      ...AddressFragment
    }
  }

  ${fragments.address}
`;

export const UPDATE_ADDRESS = gql`
  mutation UpdateAddress($address: OmsAddress!) {
    updateAddress(address: $address) {
      ...AddressFragment
    }
  }

  ${fragments.address}
`;

export const DELETE_ADDRESS = gql`
  mutation DeleteAddress($addressId: String!) {
    deleteAddress(addressId: $addressId)
  }
`;
